// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3GW-N","newExpiryDate":"styles_newExpiryDate__13ed0","footer":"styles_footer__3P6VW"};